import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true
  },
  actionTypes: {
    score: [
      '0_POINTS',
      '1_POINT',
      '2_POINTS',
      '3_POINTS',
      '4_POINTS'
    ]
  },
  modules: {
    info: [
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    throws: {
      component: 'throws-table'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    currentTeam: 1,
    score: {
      home: 0,
      away: 0
    },
    wickets: {
      home: 0,
      away: 0
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    playersCount: {
      home: 1,
      away: 1
    },
    overCount: {
      home: 0,
      away: 0
    },
    throwNumber: {
      home: 0,
      away: 0
    },
    getOvertimePeriodName: 'OT'
  }
}
